import { CssBaseline, ThemeProvider } from '@mui/material';
import React from 'react';
import { Home } from './components/Home';
import { createApplicationTheme } from './theme';

function App(): React.ReactElement {
  const theme = createApplicationTheme();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Home />
    </ThemeProvider>
  );
}

export default App;
